import { Box, xcss } from '@atlaskit/primitives';

import { CopyableErrorCode } from 'src/components/generic-message/src/copyable-error-code';
import { GenericContactSupportErrorText } from 'src/components/generic-message/src/error-state';

const sentryIdContainerStyles = xcss({
  marginTop: 'space.050',
  marginBottom: 'space.050',
});

const descriptionTextContainer = xcss({
  // copied from @atlaskit/flag/src/components/FlagDescription/styles.ts
  /* This is for the flag description to render new line characters properly */
  whiteSpace: 'pre-wrap',
});

interface FlagDescriptionProps {
  description?: string | React.ReactNode;
  sentryErrorProps?: {
    sentryId: string;
    includeOrigDesc?: boolean;
  };
}

export function FlagDescription({
  description,
  sentryErrorProps = { sentryId: '' },
}: FlagDescriptionProps) {
  const { sentryId, includeOrigDesc } = sentryErrorProps;

  // return null early if there's no sentryId and no description
  if (!sentryId && !description) {
    return null;
  }

  // return simple description if there's no sentryId
  if (!sentryId) {
    return <Box xcss={descriptionTextContainer}>{description}</Box>;
  }

  return (
    <>
      {/* generic support text (must always be included if sentry code is present) */}
      <GenericContactSupportErrorText hasCopyableCode tagName="span" />
      {/* copyable sentry code */}
      <Box xcss={sentryIdContainerStyles} as="div">
        <CopyableErrorCode source={sentryId} />
      </Box>
      {/* include original description if requested. Note: Keep it below the support
      text and sentry id so if flag scrolls the ID is still visible. */}
      {includeOrigDesc && description && (
        <Box xcss={descriptionTextContainer}>{description}</Box>
      )}
    </>
  );
}
